import React, {useState} from "react";
import "./modal.scss"
import StarRating from "./StarRating";
import {useTranslation} from "react-i18next";

export interface ModalField {
    name: string;
    label: string;
    type?: 'text' | 'tel' | 'textarea' | 'rating' | 'language' | 'workshop_type';
    placeholder?: string;
}

interface ModalProps {
    message: string;
    onConfirm: (data?: Record<string, string>) => void;
    onCancel?: () => void;
    confirmLabel?: string;
    cancelLabel?: string;
    fields?: ModalField[];
    submitted: boolean;
    confirmationText: string;
}

export const Modal = (
    { message, onConfirm, onCancel, confirmLabel = 'OK', cancelLabel = 'Annuler', fields,
        submitted, confirmationText }: ModalProps
) => {
    const {t} = useTranslation()
    const [values, setValues] = useState<Record<string, string>>({ language: 'fr', workshop_type: 'subtitle_transformation' });
    const handleConfirm = () => onConfirm(fields ? values : undefined);

    return (
        <div className="modal-overlay">
            <div className="modal-box">
                <p className="modal-message">{message}</p>
                {fields && (
                    <div className="modal-form">
                        {fields.map(field => (
                            <div key={field.name} className="modal-field">
                                <label>{field.label}</label>
                                {field.type === 'rating'
                                    ? <StarRating
                                        value={parseInt(values[field.name] || '5')}
                                        onChange={val => setValues(v => ({ ...v, [field.name]: String(val) }))}
                                    />
                                    : field.type === 'language'
                                    ? <select value={values[field.name]}
                                              onChange={e => setValues(v => ({ ...v, [field.name]: e.target.value }))}>
                                            <option value="fr">{t("languages.french")}</option>
                                            <option value="en">{t("languages.english")}</option>
                                            <option value="es">{t("languages.spanish")}</option>
                                    </select>
                                        : field.type === 'workshop_type'
                                            ? <select value={values[field.name]}
                                                      onChange={e => setValues(v => ({ ...v, [field.name]: e.target.value }))}>
                                                <option value="subtitle_transformation">{t("workshop.subtitle_transformation")}</option>
                                                <option value="subtitle_redesign">{t("workshop.subtitle_redesign")}</option>
                                                <option value="subtitle_anklets">{t("workshop.subtitle_anklets")}</option>
                                            </select>
                                        : field.type === 'textarea'
                                    ? <textarea
                                        rows={4}
                                        placeholder={field.placeholder}
                                        value={values[field.name] || ''}
                                        onChange={e => setValues(v => ({ ...v, [field.name]: e.target.value }))}
                                    />
                                    : <input
                                        type={field.type || 'text'}
                                        placeholder={field.placeholder}
                                        value={values[field.name] || ''}
                                        onChange={e => setValues(v => ({ ...v, [field.name]: e.target.value }))}
                                    />
                                }
                            </div>
                        ))}
                        {submitted && (
                            <p style={{ textAlign: 'center', color: '#5cd7de' }}>{confirmationText}</p>
                        )}

                    </div>
                )}
                <div className="modal-actions">
                    {onCancel && <button className="modal-btn modal-btn-cancel" onClick={onCancel}>{cancelLabel}</button>}
                    <button className="modal-btn modal-btn-confirm" onClick={handleConfirm}>{confirmLabel}</button>
                </div>
            </div>
        </div>
    );
};
